export class EmailNotVerifiedError extends Error {
  constructor() {
    super('You must verify your email before accessing the app.');
    this.name = 'EmailNotVerifiedError';
    Object.setPrototypeOf(this, EmailNotVerifiedError.prototype);
  }
}

export class UserNotFoundError extends Error {
  constructor() {
    super('User not found.');
    this.name = 'UserNotFoundError';
    Object.setPrototypeOf(this, UserNotFoundError.prototype);
  }
}

export class IncorrectCredentialsError extends Error {
  constructor() {
    super('Incorrect email or password.');
    this.name = 'IncorrectCredentialsError';
    Object.setPrototypeOf(this, IncorrectCredentialsError.prototype);
  }
}

export class UnkownLoginError extends Error {
  constructor() {
    super('Unknown login error.');
    this.name = 'UnkownLoginError';
    Object.setPrototypeOf(this, IncorrectCredentialsError.prototype);
  }
}

export class EmailAlreadyInUseError extends Error {
  constructor() {
    super('An account with this email already exists!');
    this.name = 'EmailAlreadyInUseError';
    Object.setPrototypeOf(this, UnkownSignupError.prototype);
  }
}

export class InvalidEmailError extends Error {
  constructor() {
    super('The email address is not valid.');
    this.name = 'InvalidEmailError';
    Object.setPrototypeOf(this, InvalidEmailError.prototype);
  }
}

export class WeakPasswordError extends Error {
  constructor() {
    super('The password is not strong enough.');
    this.name = 'WeakPasswordError';
    Object.setPrototypeOf(this, WeakPasswordError.prototype);
  }
}

export class UnkownSignupError extends Error {
  constructor() {
    super('Unknown signup error.');
    this.name = 'UnkownSignupError';
    Object.setPrototypeOf(this, UnkownSignupError.prototype);
  }
}

export class TooManyRequestsError extends Error {
  constructor() {
    super('Too many requests, please try again later.');
    this.name = 'TooManyRequestsError';
    Object.setPrototypeOf(this, TooManyRequestsError.prototype);
  }
}
